var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 36.0908H5C4.07174 36.0908 3.1815 35.7221 2.52513 35.0657C1.86875 34.4093 1.5 33.5191 1.5 32.5908V20.3408C1.5 19.4126 1.86875 18.5223 2.52513 17.8659C3.1815 17.2096 4.07174 16.8408 5 16.8408H10.25M22.5 13.3408V6.34082C22.5 4.94843 21.9469 3.61308 20.9623 2.62851C19.9777 1.64394 18.6424 1.09082 17.25 1.09082L10.25 16.8408V36.0908H29.99C30.8341 36.1004 31.6532 35.8045 32.2963 35.2578C32.9395 34.7111 33.3634 33.9504 33.49 33.1158L35.905 17.3658C35.9811 16.8642 35.9473 16.352 35.8058 15.8648C35.6644 15.3775 35.4187 14.9268 35.0858 14.544C34.7528 14.1611 34.3406 13.8552 33.8778 13.6475C33.4149 13.4397 32.9123 13.3351 32.405 13.3408H22.5Z",
    stroke: "#721BE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.ce86196fa10f74806b9d5639cd67a022.svg";
export { ForwardRef as ReactComponent };